<div class="container">
    <div class="header-action buttons-grp">
        <por-base-button [disabled]="(advanceViewTab$ | async) === advanceSetupTabs.imageAds" [featureName]="'accountSetup'" (onclick)="advanceViewTab$.next(advanceSetupTabs.accountSetup)">
            <span>{{ 'accountSetup' | translate }}</span>
        </por-base-button>

        @if (versionService.isAdvanceVersion()) {
        <por-base-button [disabled]="(advanceViewTab$ | async) === advanceSetupTabs.accountSetup" [featureName]="'imagesAds'" (onclick)="advanceViewTab$.next(advanceSetupTabs.imageAds)">
            <span>{{ 'Images/Ads' | translate }}</span>
        </por-base-button>
        }
    </div>
</div>

@if ((advanceViewTab$ | async) === advanceSetupTabs.accountSetup) {
<div class="wrapper holder">
    <div class="container">
        <h1>{{ 'adminConsumerPortalSetup' | translate }}</h1>
        <p>{{ 'adminConsumerPortalHeading' | translate }}</p>
        @if (showWysiwyg) {
        <p>{{ 'adminConsumerPortalSubHeading' | translate }}</p>
        }
        <form class="form-wrapper mt-2" [formGroup]="mandatoryForm" (ngSubmit)="onSubmit()">
            <div class="form-section">
                <h2>{{ 'adminChooseYourUrl' | translate }}</h2>
                <div class="form-group-container">
                    <ng-container>
                        <Strong>
                            {{ 'adminChooseDefaultUrl' | translate }}
                            <br />
                        </Strong>
                        <p>
                            {{ 'adminChooseYourUrlHeading' | translate }}
                            <br />
                        </p>
                        <span class="url-preview-text">{{ vanityUrl ? vanityUrl.value : '___' }}.{{ domain }}</span>
                        <p>{{ 'adminChooseYourUrlSubHeading' | translate }}</p>
                    </ng-container>
                    <p class="validEntriesText">
                        {{ 'adminChooseYourUrlValidEntries' | translate }}
                        <br />
                        {{ 'adminChooseYourUrlValidEntries1' | translate }}
                        <br />
                        {{ 'adminChooseYourUrlValidEntries2' | translate }}
                        <br />
                        {{ 'adminChooseYourUrlValidEntries3' | translate }}
                    </p>
                    <ng-container *ngIf="!isFeatureForceHidden('AssetTags') && mandatoryForm.get('enableAssetTags')?.value">
                        <div class="asset-tag-vanity-url-warning">
                            <p>
                                {{ 'AssetTagVanityUrlWarning' | translate }}
                            </p>
                        </div>
                    </ng-container>
                    <div class="form-group form-group-space vanity-url-preview">
                        <span class="label-url">{{ 'adminChooseYourUrlPara1' | translate }}</span>
                        <apx-form-field
                            [classList]="'required flex-row spinner-holder'"
                            [error]="vanityUrl?.invalid && (vanityUrl?.dirty || vanityUrl?.touched) ?
							vanityUrl?.errors?.['required'] ? ('RequiredError' | translate) :
							vanityUrl?.errors?.['noCom'] ? ('NoComError' | translate) :
							vanityUrl?.errors?.['unavailable'] ? ('UnavailableDomainError' | translate) :
							vanityUrl?.errors?.['noSpace'] ? ('spaceNotAllowed' | translate) :
							vanityUrl?.errors?.['badFormat'] ? ('badFormatError' | translate) :
							''
							: '' ">
                            <input
                                apxInput
                                type="text"
                                placeholder="{{ 'adminChooseYourUrlInputPlaceholder' | translate }}"
                                id="vanityUrl"
                                formControlName="vanityUrl"
                                [ngModel]="mandatoryForm.value.vanityUrl" />
                            @if (!vanityUrl?.invalid) {
                            <div class="flex mt-xs px-xs">
                                <div class="flex items-center justify-center text-success">
                                    <p class="p-none m-none">
                                        &nbsp; @if ((vanityUrlAvailable$ | async) === true && (vanityUrlLoading$ | async) === false) {
                                        <span>{{ 'adminChooseYourUrlDomainAvailable' | translate }}</span>
                                        }
                                    </p>
                                </div>
                            </div>
                            } @if (vanityUrlLoading$ | async) {
                            <span porIcon icon="spinner" class="spinner"></span>
                            }
                        </apx-form-field>
                        <div class="hint-text url-preview">.{{ domain }}</div>
                    </div>

                    <div class="form-section" *ngIf="!isFeatureForceHidden('AssetTags') && mandatoryForm.get('enableAssetTags')?.value">
                        <h2>
                            {{ 'AssetTagBaseUrlTitle' | translate }}
                        </h2>
                        <div class="form-group-container">
                            <div class="asset-tag-base-url-info-container">
                                <span class="url-preview-text">{{ assetTagBaseUrl() }}</span>
                                <por-base-button type="button" (onclick)="copyAssetTagBaseUrl()" class="ml-2">
                                    <mat-icon>content_copy</mat-icon>
                                    {{ 'Copy' | translate }}
                                </por-base-button>
                            </div>
                            <div class="asset-tag-base-url-info">
                                <div class="paragraph">
                                    <div>
                                        <b>{{ 'AssetTagBaseUrlLabel' | translate }}</b>
                                    </div>
                                    <div>{{ 'AssetTagBaseUrlInfo' | translate }}</div>
                                </div>

                                <div class="paragraph">
                                    <div>
                                        <b>{{ 'AssetTagInstructionsLabel' | translate }}</b>
                                    </div>
                                    <div>{{ 'AssetTagInstructions1' | translate }}</div>
                                    <div>{{ 'AssetTagInstructions2' | translate }}</div>
                                    <div>{{ 'AssetTagInstructions3' | translate }}</div>
                                </div>

                                <div class="paragraph">
                                    <div>
                                        <b>{{ 'AssetTagExampleLabel' | translate }}</b>
                                    </div>
                                    <div>{{ 'AssetTagExample1' | translate }}</div>
                                    <div>{{ 'AssetTagExample2' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>{{ 'adminLogoAndIconUpload' | translate }}</h2>
                <div class="ads-wrapper-two">
                    <div class="left-section">
                        <p>{{ 'adsectionInstruction1' | translate }}</p>
                        <p>
                            {{ 'adsectionInstruction2' | translate }}
                        </p>
                        <p>
                            {{ 'adminLogoUrlHintSize' | translate }}
                            <br />
                            {{ 'adminLogoUrlHint' | translate }}
                        </p>
                        <p>
                            {{ 'adminFaviconUrlHintSize' | translate }}
                            <br />
                            {{ 'adminFaviconUrlHint' | translate }}
                        </p>
                    </div>
                    <div class="right-section">
                        <div class="droppers-section">
                            <por-ad-drag-drop
                                (uploadSuccess)="handleFile($event, fileType.Logo)"
                                title="{{ 'logo' | translate }}"
                                [allowedExtensions]="logoAllowedExtensions"
                                [currentImage]="$any(mandatoryForm.value)?.logoUrl"></por-ad-drag-drop>
                            @if (logoUrl?.invalid && logoUrl?.errors) {
                            <div class="error logo-error-holder mt-xs px-xs ng-star-inserted">
                                <div class="logo-error text-error ng-star-inserted">
                                    <p class="p-none m-none">{{ 'invalidLogoFormat' | translate }}</p>
                                </div>
                            </div>
                            }
                            <por-ad-drag-drop
                                (uploadSuccess)="handleFile($event, fileType.Icon)"
                                title="{{ 'icon' | translate }}"
                                [currentImage]="$any(mandatoryForm.value)?.faviconUrl"></por-ad-drag-drop>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>{{ 'adminColorSelectorHeading' | translate }}</h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <apx-form-field
                            label="{{ 'Primary' | translate }}:"
                            [classList]="'required flex-row'"
                            [error]="primaryColor?.invalid && (primaryColor?.dirty || primaryColor?.touched) ?
                            primaryColor?.errors?.['required'] ? ('RequiredError' | translate) :
                            primaryColor?.errors?.['hex'] ? ('HexValid' | translate) :
                            ''
                            : '' ">
                            <div class="color-picker-input">
                                <input
                                    apxInput
                                    placeholder="{{ 'Pick or enter hex #' | translate }}"
                                    [ngModel]="mandatoryForm.value.primaryColor"
                                    [colorPicker]="selectedPrimaryColor"
                                    (colorPickerChange)="setColor('primaryColor', $event)"
                                    formControlName="primaryColor"
                                    cpOutputFormat="hex" />
                                <div class="selected-color-preview bg-primary"></div>
                            </div>
                        </apx-form-field>
                        <div class="hint-text ml-2">
                            {{ 'adminPrimaryColorHint' | translate }}
                        </div>
                    </div>
                    <div class="form-group form-group-space">
                        <apx-form-field
                            label="{{ 'Secondary' | translate }}:"
                            [classList]="'required flex-row'"
                            [error]="secondaryColor?.invalid && (secondaryColor?.dirty || secondaryColor?.touched) ?
                            secondaryColor?.errors?.['required'] ? ('RequiredError' | translate) :
                            secondaryColor?.errors?.['hex'] ? ('HexValid' | translate) :
                            ''
                            : '' ">
                            <div class="color-picker-input">
                                <input
                                    apxInput
                                    placeholder="{{ 'Pick or enter hex #' | translate }}"
                                    [ngModel]="mandatoryForm.value.secondaryColor"
                                    [colorPicker]="selectedSecondaryColor"
                                    (colorPickerChange)="setColor('secondaryColor', $event)"
                                    formControlName="secondaryColor"
                                    cpOutputFormat="hex" />
                                <div class="selected-color-preview bg-secondary"></div>
                            </div>
                        </apx-form-field>
                        <div class="hint-text ml-2">
                            {{ 'adminSecondaryColorHint' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            @if (showWysiwyg) {
            <por-admin-wysiwyg [adminConfig]="adminConfig" [logoUrl]="mandatoryForm.value.logoUrl"></por-admin-wysiwyg>
            }
            <div class="form-section">
                <h2>{{ 'adminStoreName' | translate }}</h2>
                <div class="form-group-container">
                    <p>{{ 'adminStoreNameHeading' | translate }}</p>
                    <div class="form-group form-group-space">
                        <apx-form-field
                            [classList]="'required'"
                            [error]="storeName?.invalid && (storeName?.dirty || storeName?.touched) ?
                            storeName?.errors?.['required'] ? ('RequiredError' | translate) :
                            ''
                            : '' ">
                            <input apxInput type="text" placeholder="{{ 'adminStoreNameInputPlaceholder' | translate }}" formControlName="storeName" [ngModel]="mandatoryForm.value.storeName" />
                        </apx-form-field>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>{{ 'Language' | translate }}</h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <por-language-selector
                            (selectedLocale)="handleSelectedLocale($event)"
                            [options]="languageOptions"
                            [selectedLanguageOption]="mandatoryForm.value.locale ?? ''"></por-language-selector>
                        <div class="hint-text ml-2">{{ 'LanguageHintText' | translate }}</div>
                    </div>
                </div>
            </div>
            @if (versionService.isAdvanceVersion()) {
            <div class="form-section">
                <h2>{{ 'adminEnterRequestAction' | translate }}</h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <apx-form-field
                            [classList]="'required'"
                            [error]="notificationEmail?.invalid && (notificationEmail?.dirty || notificationEmail?.touched) ?
                            notificationEmail?.errors?.['required'] ? ('RequiredError' | translate) :
                            notificationEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                            ''
                            : '' ">
                            <input apxInput type="email" placeholder="{{ 'Enter email address' | translate }}" formControlName="notificationEmail" [ngModel]="mandatoryForm.value.notificationEmail" />
                        </apx-form-field>
                        <div class="hint-text ml-2">{{ 'adminNotificationEmailHint' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>{{ 'AdminServiceRequestEmail' | translate }}</h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <apx-form-field
                            [classList]="'required'"
                            [error]="serviceRequestEmail?.invalid && (serviceRequestEmail?.dirty || serviceRequestEmail?.touched) ?
                            serviceRequestEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                            ''
                            : '' ">
                            <input
                                apxInput
                                type="email"
                                placeholder="{{ 'Enter email address' | translate }}"
                                formControlName="serviceRequestEmail"
                                [ngModel]="mandatoryForm.value.serviceRequestEmail" />
                        </apx-form-field>
                        <div class="hint-text ml-2">{{ 'AdminServiceRequestEmailHint' | translate }}</div>
                    </div>
                </div>
            </div>
            }
            <div class="form-section">
                <h2>
                    {{ 'EnterSupportEmailAddress' | translate }}
                </h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <apx-form-field
                            [classList]="'required'"
                            [error]="supportEmail?.invalid && (supportEmail?.dirty || supportEmail?.touched) ?
                            supportEmail?.errors?.['required'] ? ('RequiredError' | translate) :
                            supportEmail?.errors?.['email'] ? ('EmailValid' | translate) :
                            ''
                            : '' ">
                            <input apxInput type="email" placeholder="{{ 'Enter email address' | translate }}" formControlName="supportEmail" [ngModel]="mandatoryForm.value.supportEmail" />
                        </apx-form-field>
                        <div class="hint-text ml-2">{{ 'SupportEmailHint' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="form-section">
                <h2>
                    {{ 'PrivacyPolicy' | translate }}
                </h2>
                <div class="form-group-container">
                    <div class="form-group-container d-inline-flex">
                        <div class="toogle-wrapper toggle-wrapper-section">
                            <label>{{ 'EnablePrivacyPolicyText' | translate }}:</label>
                            <por-base-toggle
                                [parentForm]="mandatoryForm"
                                [formControlName]="'enablePrivacyPolicy'"
                                [model]="mandatoryForm.value.enablePrivacyPolicy"
                                (modelChange)="onModelChange($event, 'enablePrivacyPolicy')"></por-base-toggle>
                        </div>
                        <div class="hint-text ml-2">{{ 'EnablePrivacyPolicyHintText' | translate }}</div>
                    </div>
                    <div class="form-group">
                        <apx-form-field
                            [error]="privacyUrl?.invalid && (privacyUrl?.dirty || privacyUrl?.touched) ?
                            privacyUrl?.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                            ''
                            : '' ">
                            <input apxInput type="text" placeholder="{{ 'EnterURL' | translate }}" formControlName="privacyUrl" [ngModel]="mandatoryForm.value.privacyUrl" />
                        </apx-form-field>
                        <div class="hint-text ml-2">{{ 'PrivacyPolicyURLText' | translate }}</div>
                    </div>
                </div>
            </div>
            @if (!isFeatureForceHidden('LiveTracking')) {
            <div class="form-section">
                <h2>
                    {{ 'HAPNCredentials' | translate }}
                </h2>
                <div class="form-group-container">
                    @if (!isExternalCredentialsReady()) {
                    <span class="spinner-holder spinner-space">
                        <span porIcon icon="spinner" class="spinner position-relative"></span>
                    </span>
                    } @if (isExternalCredentialsReady()) {
                    <div>
                        <div class="form-group multi-line">
                            <apx-form-field>
                                <input apxInput type="text" placeholder="{{ 'EnterClientID' | translate }}" formControlName="hapnClientId" [ngModel]="mandatoryForm.value.hapnClientId" />
                            </apx-form-field>
                            <div class="hint-text ml-2">{{ 'ReceiveYourClientId' | translate }}</div>
                        </div>
                        <div class="form-group">
                            <apx-form-field>
                                <input apxInput type="text" placeholder="{{ 'EnterClientSecret' | translate }}" formControlName="hapnClientSecret" [ngModel]="mandatoryForm.value.hapnClientSecret" />
                            </apx-form-field>
                        </div>
                        <div class="form-group">
                            <por-base-button type="button" (onclick)="testHapnConnection()">
                                {{ 'TestHAPNConnection' | translate }}
                            </por-base-button>
                            @if (isLoadingTestHapn()) {
                            <span class="spinner-holder spinner-space spinner-inline">
                                <span porIcon icon="spinner" class="spinner position-relative"></span>
                            </span>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            }

            <! -- SMTP Configuration Section (Feature Wrapped) -->
            <div class="form-section" *ngIf="!isFeatureForceHidden('CustomSmtp')">
                <h2>{{ 'BusinessEmailSetup' | translate }}</h2>
                <div class="form-group-container">
                    <span class="spinner-holder spinner-space" *ngIf="!isSmtpConfigReady()">
                        <span porIcon icon="spinner" class="spinner position-relative"></span>
                    </span>
                    <div *ngIf="isSmtpConfigReady()">
                        <! -- Enable Toggle -->
                        <div class="form-group-container d-inline-flex">
                            <div class="toogle-wrapper toggle-wrapper-section">
                                <label>{{ 'EnableBusinessEmail' | translate }}:</label>
                                <por-base-toggle
                                    [parentForm]="mandatoryForm"
                                    [formControlName]="'smtpEnabled'"
                                    [model]="mandatoryForm.get('smtpEnabled')?.value"
                                    (modelChange)="onModelChange($event, 'smtpEnabled')"></por-base-toggle>
                            </div>
                            <div class="hint-text ml-2">{{ 'BusinessEmailHelperText' | translate }}</div>
                        </div>

                        <! -- SMTP Fields (shown when enabled) -->
                        <div *ngIf="mandatoryForm.value.smtpEnabled">
                            <! -- SMTP Host -->
                            <div class="form-group multi-line smtp-field-row">
                                <span class="smtp-field-label required">{{ 'SmtpHost' | translate }}:</span>
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="smtpHost?.invalid && (smtpHost?.dirty || smtpHost?.touched) ?
                                        smtpHost?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                        : ''">
                                    <input apxInput type="text" placeholder="{{ 'SmtpHostPlaceholder' | translate }}" formControlName="smtpHost" [ngModel]="mandatoryForm.value.smtpHost" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'SmtpHostHint' | translate }}</div>
                            </div>

                            <! -- SMTP User -->
                            <div class="form-group multi-line smtp-field-row">
                                <span class="smtp-field-label required">{{ 'SmtpUser' | translate }}:</span>
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="smtpUser?.invalid && (smtpUser?.dirty || smtpUser?.touched) ?
                                        smtpUser?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                        : ''">
                                    <input apxInput type="text" placeholder="{{ 'SmtpUserPlaceholder' | translate }}" formControlName="smtpUser" [ngModel]="mandatoryForm.value.smtpUser" />
                                </apx-form-field>
                            </div>

                            <! -- SMTP Password -->
                            <div class="form-group multi-line smtp-field-row">
                                <span class="smtp-field-label" [class.required]="!hasExistingSmtpConfig()">{{ 'SmtpPassword' | translate }}:</span>
                                <apx-form-field
                                    [classList]="hasExistingSmtpConfig() ? '' : 'required'"
                                    [error]="smtpPassword?.invalid && (smtpPassword?.dirty || smtpPassword?.touched) ?
                                        smtpPassword?.errors?.['required'] ? ('RequiredError' | translate) : ''
                                        : ''">
                                    <input
                                        apxInput
                                        type="password"
                                        autocomplete="new-password"
                                        [placeholder]="hasExistingSmtpConfig() ? ('LeaveBlankToKeepCurrent' | translate) : ('SmtpPasswordPlaceholder' | translate)"
                                        formControlName="smtpPassword"
                                        [ngModel]="mandatoryForm.value.smtpPassword" />
                                </apx-form-field>
                            </div>

                            <! -- SMTP Encryption -->
                            <div class="form-group multi-line smtp-field-row">
                                <span class="smtp-field-label">{{ 'SmtpEncryption' | translate }}:</span>
                                <select class="smtp-select" formControlName="smtpEncryption">
                                    <option value="TLS">TLS ({{ 'Port' | translate }} 587)</option>
                                    <option value="SSL">SSL ({{ 'Port' | translate }} 465)</option>
                                    <option value="NONE">{{ 'None' | translate }} ({{ 'Port' | translate }} 25)</option>
                                </select>
                            </div>

                            <! -- SMTP From Address -->
                            <div class="form-group multi-line smtp-field-row">
                                <span class="smtp-field-label required">{{ 'SmtpFromAddress' | translate }}:</span>
                                <apx-form-field
                                    [classList]="'required'"
                                    [error]="smtpFromAddress?.invalid && (smtpFromAddress?.dirty || smtpFromAddress?.touched) ?
                                        smtpFromAddress?.errors?.['required'] ? ('RequiredError' | translate) :
                                        smtpFromAddress?.errors?.['email'] ? ('EmailValid' | translate) : ''
                                        : ''">
                                    <input
                                        apxInput
                                        type="email"
                                        placeholder="{{ 'SmtpFromAddressPlaceholder' | translate }}"
                                        formControlName="smtpFromAddress"
                                        [ngModel]="mandatoryForm.value.smtpFromAddress" />
                                </apx-form-field>
                                <div class="hint-text ml-2">{{ 'SmtpFromAddressHint' | translate }}</div>
                            </div>

                            <! -- Test Email Button -->
                            <div class="form-group smtp-field-row">
                                <span class="smtp-field-label">&nbsp;</span>
                                <por-base-button type="button" (onclick)="handleTestEmailClick()" [disabled]="isTestEmailDisabled()">
                                    {{ getTestEmailButtonLabel() }}
                                </por-base-button>
                                <span class="spinner-holder spinner-space spinner-inline" *ngIf="isSmtpSaving() || isSmtpTesting()">
                                    <span porIcon icon="spinner" class="spinner position-relative"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h2>
                    {{ 'SetupDefaultPaymentDepotStore' | translate }}
                </h2>
                <div class="form-group-container">
                    @if (!mandatoryForm.value.defaultPaymentMid) {
                    <div class="warning-callout">
                        <div class="warning-icon">
                            <i class="material-icons">warning</i>
                        </div>
                        <div class="warning-text">
                            {{ 'NoDefaultPaymentStoreSet' | translate }}
                        </div>
                    </div>
                    }
                    <div class="form-group form-group-space">
                        @if (!isDefaultPaymentMidReady()) {
                        <span class="spinner-holder">
                            <span porIcon icon="spinner" class="spinner position-relative"></span>
                        </span>
                        } @if (isDefaultPaymentMidReady()) {
                        <por-base-select
                            label="Select"
                            [options]="defaultPaymentDepotOptions"
                            (modelChange)="handleSelectDefaultPaymentDepot($event)"
                            [formControlName]="'defaultPaymentMid'"
                            [parentForm]="mandatoryForm"
                            [model]="mandatoryForm.value.defaultPaymentMid ?? ''"
                            porAddFeature
                            featureName="default-payment-depot-selector"></por-base-select>
                        }
                        <div class="hint-text ml-2">
                            <div class="help-info">
                                <i class="material-icons help-icon">help</i>
                                <span class="help-text">{{ 'DefaultPaymentStoreHelpText' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (payMinimumAmountDueVisible) {
            <div class="form-section radio-section">
                <h2>
                    {{ 'SettingForInitialDepositPaymentText' | translate }}
                </h2>
                <div class="form-group-container">
                    <por-base-radio
                        [style]="'radioButtonBlock'"
                        [values]="[
                            { text: 'MinimumPaymentDueAdmin' | translate, value: payMinimumAmountEnum.PayMinimumAmount.toString() },
                            { text: 'InitialPaymentDueAdmin' | translate, value: payMinimumAmountEnum.InitialPaymentDue.toString() },
                            { text: 'Other' | translate, value: payMinimumAmountEnum.Other.toString() }
                        ]"
                        formControlName="payMinimumAmountDueType"
                        (modelChange)="onPayMinimumAmountDueTypeChange($event)"
                        [model]="mandatoryForm.value.payMinimumAmountDueType"></por-base-radio>
                </div>
                <div class="form-group-container radio-asigned">
                    <apx-form-field
                        [error]="payMinimumAmountDueText && payMinimumAmountDueText.invalid && (payMinimumAmountDueText.dirty || payMinimumAmountDueText.touched) ?
                        payMinimumAmountDueText.errors?.['required'] ? ('RequiredError' | translate) :
                        payMinimumAmountDueText.errors?.['noSpecialCharacters'] ? ('InvalidSpecialCharacters' | translate) :
                        ''
                        : '' ">
                        <mat-label class="mini-label">{{ 'EnterText' | translate }}</mat-label>
                        <input
                            apxInput
                            type="text"
                            placeholder="{{ 'InitialAmountToConfirmYourReservation' | translate }}"
                            formControlName="payMinimumAmountDueText"
                            [ngModel]="mandatoryForm.value.payMinimumAmountDueText"
                            [disabled]="mandatoryForm.get('payMinimumAmountDueType')?.value !== payMinimumAmountEnum.Other.toString()" />
                    </apx-form-field>
                </div>
            </div>
            } @if (versionService.isBasicExternalConsumerPortalURL()) {
            <div class="form-section">
                <h2>
                    {{ 'ExternalConsumerPortalURL' | translate }}
                </h2>
                <div class="form-group-container">
                    <div class="form-group form-group-space">
                        <apx-form-field
                            [error]="externalConsumerPortalURL && externalConsumerPortalURL.invalid && (externalConsumerPortalURL.dirty || externalConsumerPortalURL.touched) ?
                            externalConsumerPortalURL.errors?.['invalidUrl'] ? ('InvalidUrl' | translate) :
                            ''
                            : '' ">
                            <input
                                apxInput
                                type="email"
                                placeholder="{{ 'EnterUrl' | translate }}"
                                formControlName="externalConsumerPortalURL"
                                [ngModel]="mandatoryForm.value.externalConsumerPortalURL" />
                        </apx-form-field>
                    </div>
                </div>
            </div>
            } @if (featureToggleService.isSyrinx()) {
            <div class="form-section">
                <h2>
                    {{ 'DisplayCertificateConfig' | translate }}
                </h2>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'DisplayServiceCertificates' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'displayServiceCertificate'"
                            [model]="mandatoryForm.value.displayServiceCertificate"
                            (modelChange)="onModelChange($event, 'displayServiceCertificate')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'DisplayServiceCertificatesHint' | translate }}</div>
                </div>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'DisplayInspectionDocument' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'displayInspectionDocument'"
                            [model]="mandatoryForm.value.displayInspectionDocument"
                            (modelChange)="onModelChange($event, 'displayInspectionDocument')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'DisplayInspectionDocumentHint' | translate }}</div>
                </div>
            </div>
            }
            <div class="form-section">
                <h2>
                    {{ 'AccessConfig' | translate }}
                </h2>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'SecureUrlLoginRequired' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'secureUrlLoginRequired'"
                            [model]="mandatoryForm.value.secureUrlLoginRequired"
                            (modelChange)="onModelChange($event, 'secureUrlLoginRequired')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'SecureUrlLoginRequiredHint' | translate }}</div>
                </div>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'MultiplePaymentAbilityText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'multiplePaymentAbility'"
                            [model]="mandatoryForm.value.multiplePaymentAbility"
                            (modelChange)="onModelChange($event, 'multiplePaymentAbility')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'MultiplePaymentAbilityHintText' | translate }}</div>
                </div>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'QuotesPaymentAbilityText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'quotesPaymentAbility'"
                            [model]="mandatoryForm.value.quotesPaymentAbility"
                            (modelChange)="onModelChange($event, 'quotesPaymentAbility')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'QuotesPaymentAbilityHintText' | translate }}</div>
                </div>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'ShowZeroQuantityItemsText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'showZeroQuantityItems'"
                            [model]="mandatoryForm.value.showZeroQuantityItems"
                            (modelChange)="onModelChange($event, 'showZeroQuantityItems')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'ShowZeroQuantityItemsHintText' | translate }}</div>
                </div>
            </div>
            @if (versionService.isAdvanceVersion()) {
            <div class="form-section">
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'CallOffAbilityText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'callOffAbility'"
                            [model]="mandatoryForm.value.callOffAbility"
                            (modelChange)="onModelChange($event, 'callOffAbility')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'CallOffAbilityHintText' | translate }}</div>
                </div>
                @if (!featureToggleService.isSyrinx()) {
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'TrackingTabText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'trackingTab'"
                            [model]="mandatoryForm.value.trackingTab"
                            (modelChange)="onModelChange($event, 'trackingTab')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'TrackingTabHintText' | translate }}</div>
                </div>
                }
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'RequestServiceAbilityText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'requestServiceAbility'"
                            [model]="mandatoryForm.value.requestServiceAbility"
                            (modelChange)="onModelChange($event, 'requestServiceAbility')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'RequestServiceAbilityHintText' | translate }}</div>
                </div>
                @if (!isFeatureForceHidden('LiveTracking')) {
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'LiveTrackingText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'liveTracking'"
                            [model]="mandatoryForm.value.liveTracking"
                            (modelChange)="onModelChange($event, 'liveTracking')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'LiveTrackingHintText' | translate }}</div>
                </div>
                }
            </div>
            }

            @if (!isFeatureForceHidden('AssetTags')) {
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'AssetTagToggleText' | translate }}:</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'enableAssetTags'"
                            [model]="mandatoryForm.value.enableAssetTags"
                            (modelChange)="onModelChange($event, 'enableAssetTags')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'AssetTagToggleHintText' | translate }}</div>
                </div>
            }

            <!-- Auto-Reservation Section (Feature Wrapped) -->
            <div class="form-section" *ngIf="!isFeatureForceHidden('AutoConvertQuotes')">
                <h2>{{ 'AutoReservationTitle' | translate }}</h2>
                <div class="form-group-container d-inline-flex">
                    <div class="toogle-wrapper">
                        <label>{{ 'AutoConvertQuotesLabel' | translate }}</label>
                        <por-base-toggle
                            [parentForm]="mandatoryForm"
                            [formControlName]="'autoConvertQuotes'"
                            [model]="mandatoryForm.value.autoConvertQuotes"
                            (modelChange)="onModelChange($event, 'autoConvertQuotes')"></por-base-toggle>
                    </div>
                    <div class="hint-text ml-2">{{ 'AutoConvertQuotesHintText' | translate }}</div>
                    <div class="hint-text ml-2">
                        {{ 'AutoConvertUnifiedNumberingHint' | translate }}
                        <a href="https://por.my.site.com/uLearn/s/article/Unified-Numbering-Contract-Status-Change-445182718?language=en_US" target="_blank">{{ 'ReadMore' | translate }}</a>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="form-group-container">
                    <por-base-button
                        (onclick)="onSubmit()"
                        class="theme-button apply-btn"
                        [disabled]="mandatoryForm.invalid || (vanityUrlLoading$ | async) || (uploading$ | async) || false"
                        [featureName]="'admin-save-button-data'">
                        {{ 'Save' | translate }}
                    </por-base-button>
                </div>
            </div>
        </form>
    </div>
</div>
} @if ((advanceViewTab$ | async) === advanceSetupTabs.imageAds) {
<div class="wrapper holder">
    <div class="container">
        <por-admin-ad-setting [formValues]="$any(mandatoryForm).value" (submitForm)="saveOrganizationConfig($event)" (uploadSuccess)="afterUploadFile($any($event))"></por-admin-ad-setting>
    </div>
</div>
} @if (isDialogEnabled) {
<por-app-confirm-dialog [message]="'adminConsumerPortalSetupSuccess' | translate" (confirmed)="isDialogEnabled = false"></por-app-confirm-dialog>
}
